<template>
	<v-app>
		<!-- mobile view -->
		<div id="nav" v-if="$vuetify.breakpoint.smAndDown" data-cy="appHeader">
			<template>
				<v-app-bar>
					<a class="logoLink" href="/">
						<img
							class="mr-3"
							:src="require('./assets/img/alturos-destinations-logo-2023-black.png')"
							height="40"
							alt="Alturos Destinaltions Logo"
						/>
					</a>
					<div class="headline text-uppercase" name="appBarTitle">
						<span style="font-size: calc(1vw + 2vh + 0vmin);">Report </span>
						<span class="font-weight-light" style="font-size:calc(1vw + 2vh + 0vmin);"> Center</span>
					</div>

					<v-container style="float: right; width: 60px; margin-right: unset; padding: unset;">
						<v-btn
							id="menuButtonMobileView"
							style="float: right;"
							color="#64c823"
							outlined
							@click.stop="drawer = !drawer"
						>
						<v-icon>mdi-menu</v-icon>
						</v-btn>
					</v-container>
				</v-app-bar>

				<v-sheet
					class="mx-auto overflow-hidden"
					height="160px"
					width="100%"
					v-if="drawer"
				>

				<v-navigation-drawer
					v-model="drawer"
					absolute
					right
					temporary
					>
					<v-list
						nav
						dense
					>
						<v-list-item-group
							v-model="group"
							active-class="light-green--text text--accent-4"
						>
							<v-list-item
								id="profileLink"
								@click="callProfileRoute"
								style="padding-bottom: 10px; padding-top: 5px;"
							>
								<v-list-item-title>
									<v-badge
										color="blue"
										v-model="$store.state.unseenFileShow"
									>
										<template v-slot:badge>
												<span>{{$store.state.unseenFileCount}}</span>
										</template>
										<v-icon id="profileIcon">mdi-account</v-icon>
											{{txt.profile}}
									</v-badge>
								</v-list-item-title>
							</v-list-item>
							<v-divider></v-divider>
							<v-list-item
								id="logoutListItem"
								@click="$keycloak.logoutFn"
								v-if="$keycloak.authenticated"
								style="padding-top: 15px;"
							>
								<v-list-item-title><v-icon>mdi-logout</v-icon>{{ txt.logout }}</v-list-item-title>
							</v-list-item>
						</v-list-item-group>
					</v-list>
					</v-navigation-drawer>
				</v-sheet>
			</template>
		</div>

		<!-- desktop view -->
		<div id="nav" data-cy="appHeader" v-else>
			<v-app-bar>
			<a class="logoLink" href="/">
				<img
				class="mr-3"
				:src="require('./assets/img/alturos-destinations-logo-2023-black.png')"
				height="40"
				alt="Alturos Destinaltions Logo"
				/>
			</a>

			<v-app-bar-title class="headline text-uppercase reportCenterTitle">
				<span>Report </span>
				<span class="font-weight-light"> Center</span>
			</v-app-bar-title>

			<v-btn id="profile"  class="ma-3 lastUpdate" outlined v-if="$keycloak.authenticated">
				<router-link id="profileRouter" to="/profile" tag="button">
					<v-badge
						color="blue"
						v-model="$store.state.unseenFileShow"
					>
						<template v-slot:badge>
							<span>{{$store.state.unseenFileCount}}</span>
						</template>
						<v-icon id="profileIcon">mdi-account</v-icon>
						{{txt.profile.toUpperCase()}}
					</v-badge>
				</router-link>
			</v-btn>

			<v-btn id="logout" class="ma-3" outlined @click="$keycloak.logoutFn" v-if="$keycloak.authenticated">
				<v-icon>mdi-logout</v-icon>
				{{ txt.logout }}
			</v-btn>
			</v-app-bar>
		</div>

		<!-- reports -->
		<router-view />

		<v-alert class="logoutAlert" type="warning" v-show="contactAdminVisible">
			{{ txt.contactAdmin }}
		</v-alert>
		<div class="versionNumber" @click="countTillDarkMode">{{versionNumber}} {{commit}}</div>
	</v-app>
</template>

<script>
import axios from 'axios'
import { version } from '../package.json'

export default {
	data() {
		return {
			txt: {
				logout: 'Logout',
				contactAdmin: `You seem to be new here. To get permission to see 
						the reports, please contact report-center@alturos.com!`,
				profile: 'Profile',
			},
			logoutUrl: '',
			contactAdminVisible: false,
			versionNumber: '',
			drawer: false,
			group: null,
			commit: '',
		}
	},
	methods: {
		async getApprovedReports() {
			try {
				// eslint-disable-next-line no-undef
				const r = await axios.get(`${config.baseAPIurl}/index/approved-reports`)
				this.$data.contactAdminVisible = false
				this.$data.approvedReports = r.data.permittedReports
				this.$data.approvedRoles = r.data.permittedRoles
			} catch (error) {
				this.$data.contactAdminVisible = true
			}
		},
		countTillDarkMode() {
			// eslint-disable-next-line no-unused-expressions
			(this.$store.state.count < 10) ? this.$store.commit('increment') : this.$store.commit('reset')
			this.checkDarkmode()
		},
		checkDarkmode() {
			this.$vuetify.theme.isDark = (this.$store.state.count == 10)
		},
		setVersion() {
			this.versionNumber = process.env.VUE_APP_VERSION || version
		},
		checkForUnseenFiles() {
			this.$store.commit('unseenFiles')
		},
		callProfileRoute() {
			this.$router.push({ path: '/profile' })
		},
		setCommit() {
			if (process.env.VUE_APP_COMMIT) this.commit = ` - ${process.env.VUE_APP_COMMIT}`
		},
	},
	mounted() {
		this.$nextTick(async () => {
			// this.getApprovedReports()
			this.checkDarkmode()
			this.setVersion()
			this.checkForUnseenFiles()
			this.setCommit()
		})
	},
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav a:last-child {
  border-right: 0;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
  padding: 0 5px;
  border-right: 1px solid black;
}

#logout {
  color: #64c823;
  text-decoration-color: black !important;
  position: absolute;
  right: 0;
}

#logoutAlert {
  position: absolute;
  padding-top: 250px;
}

.logoLink {
  border-right: none !important;
}

.versionNumber{
   position:absolute;
   bottom:0;
   padding-top: 15px;
   width:100%;
   height:25px;
   font-size: 12px;
}

.lastUpdate{
	float: right;
	padding: 10px;
	padding-top: 30px;
	color: rgba(0, 0, 0, 0.7);
}

.reportCenterTitle {
	padding-right: 10px;
}

</style>
